import React from 'react'
import { FaWhatsapp, FaInstagram, FaEnvelope, FaFacebook } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-container">

      <div className="footer-row">
        <div className="footer-column">
          <div className="brand-container">
            <h1 className="brand-name">Ad</h1>
            <small>aremudami_luxury</small>
            <small>Your trusted partner in luxurious real estate success.</small>
          </div>
        </div>

        <div className="footer-sub">

          <div className="footer-column" aria-label="Contact Information">
            <h3>Contact Us</h3>
            <ul>
              <li>Lekki, Lagos</li>
              <li><a href="tel:+2348156959983">Phone: +2348156959983</a></li>
            </ul>
          </div>

          <div className="footer-column" aria-label="Footer Navigation">
            <h3>Quick Links</h3>
            <ul>
              <li><NavLink to="/">Home</NavLink></li>
              <li><NavLink to="/listing">Property Listing</NavLink></li>
              <li><NavLink to="/about">About</NavLink></li>
              <li><NavLink to="/contact">Contact</NavLink></li>
            </ul>
          </div>

          <div className="footer-column" aria-label="Social Links">
            <h3>Social Links</h3>
            <ul>
             
              <li><a href="mailto:aremudami58@gmail.com">Email: <FaEnvelope /></a></li>
              <li><a href="/about">Facebook: <FaFacebook /></a></li>
              <li><a href="https://wa.me/+2348156959983">WhatsApp: <FaWhatsapp /></a></li>
              <li><a href="https://www.instagram.com/aremudami_luxury">Instagram: <FaInstagram /></a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <center>
          <ul>
            <li>&copy; 2023 aremudami_luxury. All rights reserved.</li>
            <li>Developed by Irawo</li>
            <li><a href="mailto:timothyaremu63@gmail.com">Email: timothyaremu63@gmail.com</a></li>
          </ul>
        </center>
      </div>
    </footer>
  );
}

export default Footer
